function countWords(str: any) {
  if (str.trim() === "") {
    return 0;
  }
  return str.trim().split(/\s+/).length;
}

export default countWords;
